<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 23 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2739 9.89949L22.3345 8.83883L21.2739 7.77817L13.4957 0L11.3744 2.12132L16.5919 7.33883H3.37175e-07L0 10.3388H16.5919L11.3744 15.5563L13.4957 17.6777L21.2739 9.89949Z" fill="white"/>
  </svg>
</template>
